import { mapMutations, mapGetters } from 'vuex'

export default {
   name: 'ListSearch',
   props: {
      items: {
         type: Array | Object,
         required: true
      },
      searchIndex: {
         type: String,
         required: true
      },
      noMatchFoundLabel: {
         type: String,
         required: true
      },
      searchHint: {
         type: String,
         required: true
      },
      filterTrigger: {
         type: Number,
         required: false
      }
   },
   data() {
      return {
         input: '',
         filteredItems: null,
         moreIncrement: 10,
         visibleItemCount: 10,
         itemCount: null,
         showMoreCount: 10,
         openCount: 10,
         incrementByCount: 10,
         nothingFound: false,
         allItems: null,
         baseURI: this.$parent.$vnode
      }
   },
   watch: {
      showMoreCount(newCount) {
         this.hideShowMore(newCount)
      },
      filterTrigger() {
         this.change(this.input)
      }
   },

   created() {
      let component = this.$root.$route.name

      if (component === 'AllStations') {
         this.input = this.getAllStationsListInput
      } else if (component === 'stationAlerts') {
         this.input = this.getStationAlertListSearchInput
      } else if (component === 'Alerts') {
         this.input = this.getAlertListSearchInput
      } else if (component === 'StationsInRange') {
         this.input = this.getStationsInRangeListInput
      }

      this.itemCount = this.items.length
      this.filteredItems = this.items.slice(0, this.visibleItemCount)
      this.allItems = this.items
      this.filter(this.input)
   },
   methods: {
      ...mapMutations(['setAlertListSearchInput', 'setAllStationsListInput', 'setStationAlertListSearchInput', 'setStationsInRangeSearchInput']),
      fixInitialItemsCount() {
         if (this.visibleItemCount % 10 !== 0) {
            this.visibleItemCount = this.itemCount
            this.showMoreCount = 0
         }
         if (this.visibleItemCount === this.itemCount) {
            this.showMoreCount = 0
         }
      },
      hideShowMore(newCount) {
         let showMoreButton = document.getElementById('show-more-button').shadowRoot.querySelector('sdx-button')

         if (this.visibleItemCount === this.itemCount) {
            showMoreButton.style.display = 'none'
         }

         if (newCount <= 0) {
            showMoreButton.style.display = 'none'
         } else {
            showMoreButton.style.display = 'block'
         }
      },
      change(input) {
         let component = this.$root.$route.name

         if (component === 'AllStations') {
            this.setAllStationsListInput(input)
         } else if (component === 'stationAlerts') {
            this.setStationAlertListSearchInput(input)
         } else if (component === 'Alerts') {
            this.setAlertListSearchInput(input)
         } else if (component === 'StationsInRange') {
            this.setStationsInRangeSearchInput(input)
         } else {
            this.input = input
         }
         this.filter(input.toLowerCase())
      },
      submit(input) {
         this.filter(input.toLowerCase())
      },
      filter(input) {
         this.input = input
         let _this = this
         this.allItems = this.items.filter(function(item) {
            return item[_this.searchIndex].toLowerCase().includes(input)
         })

         this.itemCount = this.allItems.length
         if (this.itemCount !== this.visibleItemCount) {
            if (this.itemCount === 0) {
               this.nothingFound = true
               this.showMoreCount = 0
            } else if (this.itemCount < 10) {
               this.showMoreCount = 0
               this.moreIncrement = this.itemCount
               this.openCount = this.itemCount
               this.visibleItemCount = this.itemCount
               this.nothingFound = false
            } else if (this.itemCount === 10) {
               this.showMoreCount = 0
               this.nothingFound = false
            } else if (this.itemCount < 20) {
               this.showMoreCount = this.itemCount - 10
               this.visibleItemCount = 10
               this.nothingFound = false
               this.moreIncrement = 10
            } else {
               this.showMoreCount = 10
               this.openCount = 10
               this.moreIncrement = 10
               this.visibleItemCount = 10
               this.nothingFound = false
            }
         }
         this.fixInitialItemsCount()
         this.filteredItems = this.allItems.slice(0, this.visibleItemCount)
      },
      showMore() {
         this.moreIncrement += 10

         if (this.visibleItemCount + this.showMoreCount === this.itemCount) {
            this.visibleItemCount += this.showMoreCount
         } else {
            this.visibleItemCount += 10
         }

         this.filteredItems = this.allItems.slice(0, this.visibleItemCount)
         if (this.itemCount - 10 <= this.visibleItemCount) {
            this.showMoreCount = this.itemCount - this.visibleItemCount
         }
         this.fixInitialItemsCount()
      }
   },
   computed: {
      ...mapGetters([
         'getIsAllAlerts',
         'getAlertListSearchInput',
         'getStationAlertListSearchInput',
         'getAllStationsListInput',
         'getStationsInRangeListInput'
      ])
   }
}
